import React, { useEffect } from "react";
import * as S from "./OmbudsmanSuccess.style";
import { Text } from "@gcs/design-system/react";

const OmbudsmanSuccess = ({ protocol, strDate }) => {
  const dateFormatted = new Date(strDate).toLocaleDateString("pt-BR");

  useEffect(() => {
    document
      .getElementById("ombudsman-sucess")
      .scrollIntoView({ block: "center", behavior: "smooth" });
  }, []);

  return (
    <S.FlexColumn id="ombudsman-sucess">
      <S.MainContent width="96px">
        <S.StyledBlueSuccess />
        <S.FlexColumn>
          <Text variant="headline-04" style={{ paddingBottom: "16px" }}>
            Sua ouvidoria foi registrada com sucesso!
          </Text>
          <Text variant="body02-lg" style={{ paddingBottom: "32px" }}>
            Protocolo nº <strong>{protocol}</strong>
          </Text>
        </S.FlexColumn>
      </S.MainContent>

      {strDate ? (
        <Text variant="body02-md" style={{ paddingTop: "32px" }}>
          Sua ouvidoria será concluída até <strong>{dateFormatted}</strong> e
          até lá podemos entrar em contato sobre a sua solicitação, fique de
          olho.
        </Text>
      ) : null}
    </S.FlexColumn>
  );
};

export default OmbudsmanSuccess;
